const config = {
    api_base_url: "https://api.isrc.app/v1",
    site_base_url: "https://admin.isrc.app",
    orb_auth_url: "https://auth.orbmusic.com.br?app=08fa450bd8ba63cbe03dcec72953bd3d03489ca96b496d8928deadd6d4515ea1",
    orb_logout_url: "https://auth.orbmusic.com.br/logout?app=08fa450bd8ba63cbe03dcec72953bd3d03489ca96b496d8928deadd6d4515ea1"
}

export default config;